import { render, staticRenderFns } from "./ProductListBatchPriceValueManagementView.vue?vue&type=template&id=bbbb762c&scoped=true&"
import script from "./ProductListBatchPriceValueManagementView.vue?vue&type=script&lang=js&"
export * from "./ProductListBatchPriceValueManagementView.vue?vue&type=script&lang=js&"
import style0 from "./ProductListBatchPriceValueManagementView.vue?vue&type=style&index=0&id=bbbb762c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbb762c",
  null
  
)

export default component.exports